var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.4001 0H16.6001V1.6H21.4001V21.6C21.4001 22.9255 20.3256 24 19.0001 24H3.0001C1.67461 24 0.600098 22.9255 0.600098 21.6V1.6H5.4001V0ZM7.0001 1.6H15.0001V4C15.0001 4.44183 14.6419 4.8 14.2001 4.8H7.8001C7.35827 4.8 7.0001 4.44183 7.0001 4V1.6ZM9.88352 8.84961H4.65014V10.3496H9.88352V8.84961ZM17.3501 13.6496H4.65014V15.1496H17.3501V13.6496ZM17.3501 18.4496H12.1168V19.9496H17.3501V18.4496Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales);
export default __webpack_public_path__ + "static/media/sales.69499c48eb173c39afc4c9b55e471c4e.svg";
export { ForwardRef as ReactComponent };